import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { getUserSummaryReportOptions } from '@cfa/pathway-fe-shared/xp';

import { processUserReportPlans } from '@/services/modelHelper';

import useAuth from './useAuth';

import { activeLicenseeLocationAtom } from '@/atoms/licensee-location';

const useGetXPSummaryReportByUser = (userId?: string, skip = false) => {
  const { data: auth } = useAuth();
  const userIsLicenseeStaff = auth?.userIsLicenseeStaff;
  const isLicenseeUser = auth?.isLicensee;
  const activeLicenseeLocation = useAtomValue(activeLicenseeLocationAtom);

  const isLicenseeRelated = !!userIsLicenseeStaff || !!isLicenseeUser;
  const skipUserReportIfLicenseeLocationNotSelected =
    isLicenseeRelated && !activeLicenseeLocation?.number;
  const selectedLicenseeLocation = isLicenseeRelated
    ? activeLicenseeLocation?.number
    : undefined;

  const isQueryEnabled =
    !!userId && !skip && !skipUserReportIfLicenseeLocationNotSelected;
  const resolvedUserId = userId ?? '';

  const {
    data: xpReportsData,
    isFetching: isFetchingXpReport,
    isPending: isPendingXpReport,
    error,
  } = useQuery({
    ...getUserSummaryReportOptions({
      path: { userId: resolvedUserId },
      query: { locationNumber: selectedLicenseeLocation },
    }),
    enabled: isQueryEnabled,
    select: data => processUserReportPlans(data),
  });

  return {
    xpReportsData,
    isFetchingXpReport: isQueryEnabled
      ? isFetchingXpReport || isPendingXpReport
      : false,
    errorXpReports: error,
  };
};

export default useGetXPSummaryReportByUser;
